import { render, staticRenderFns } from "./EditServiceDirectory.vue?vue&type=template&id=2bc264ca&"
import script from "./EditServiceDirectory.vue?vue&type=script&lang=js&"
export * from "./EditServiceDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports